export const RANKING = "RANKING"
export const RANKING_FETCH_CONFIG_LIST = "RANKING_FETCH_CONFIG_LIST"
export const RANKING_FETCH_CONFIG_FILTER_LIST =
  "RANKING_FETCH_CONFIG_FILTER_LIST"
